import { shouldPolyfill } from '@formatjs/intl-listformat/should-polyfill';

async function getLocale(locale) {
    if (locale === 'da-DK') return import(`@formatjs/intl-listformat/locale-data/da`);
    if (locale === 'sv-SE') return import(`@formatjs/intl-listformat/locale-data/se`);
    if (locale === 'nb-NO') return import(`@formatjs/intl-listformat/locale-data/no`);

    return import(`@formatjs/intl-listformat/locale-data/da`);
}

export default async function polyfill(locale: string) {
    const unsupportedLocale = shouldPolyfill(locale);
    // This locale is supported
    if (!unsupportedLocale) {
        return;
    }
    // Load the polyfill 1st BEFORE loading data
    await import('./locale');
    await import('@formatjs/intl-listformat/polyfill-force');
    await getLocale(locale);
}
